// extracted by mini-css-extract-plugin
export default {"img":"ImageSection_img__emb4v"};